<div class="row">
  <div mat-dialog-header class="col-12">
    <h1>Calculate Income</h1>
  </div>
  <div>
    <mat-dialog-content #scroll class="dialog-container col-12">
      <form #calculateForm="ngForm" class="row">
        @if (modalData.AnnuityWizard) {
          <mat-form-field class="col-6">
            <mat-label>State of Issue</mat-label>
            <mat-select
              name="state"
              required
              [(ngModel)]="modalData.AnnuityWizard.StateOfIssue"
            >
              @for (state of states; track state) {
                <mat-option [value]="state.value">
                  {{ state.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        @if (modalData.ClientEstimates) {
          <mat-form-field class="col-6">
            <mat-label>Age</mat-label>
            <input
              matInput
              name="age"
              type="number"
              step="1"
              required
              [(ngModel)]="modalData.ClientEstimates.Age"
            />
          </mat-form-field>
        }

        @if (modalData.AnnuityWizard) {
          <mat-form-field class="col-6">
            <mat-label>Age of Annuitant at First Withdrawal</mat-label>
            <input
              matInput
              name="ageNeeded"
              type="number"
              step="1"
              required
              [(ngModel)]="modalData.AnnuityWizard.AgeNeeded"
            />
          </mat-form-field>
        }

        <div
          class="container col-6 radio-btns"
          [ngClass]="{
            invalid: invalidAfterSubmit && !modalData.ClientPerson.Gender,
          }"
        >
          <div class="w-100">Gender*</div>
          @if (modalData.ClientPerson) {
            <mat-radio-group
              name="gender"
              required
              [(ngModel)]="modalData.ClientPerson.Gender"
            >
              <mat-radio-button value="M">Male</mat-radio-button>
              <mat-radio-button value="F" class="ms-2">Female</mat-radio-button>
            </mat-radio-group>
          }
        </div>

        <div
          class="container col-11 radio-btns"
          [ngClass]="{
            invalid: invalidAfterSubmit && !modalData.ClientPerson.Gender,
          }"
        >
          <div class="w-100">Solve For Premium or Income Needed*</div>
          @if (modalData.ClientPerson) {
            <mat-radio-group
              name=" solveForPremium"
              required
              [(ngModel)]="modalData.AnnuityWizard.SolveType"
            >
              <mat-radio-button value="F">Premium</mat-radio-button>
              <mat-radio-button value="B" class="ms-2">Income</mat-radio-button>
            </mat-radio-group>
          }
        </div>

        @if (
          modalData.AnnuityWizard && modalData.AnnuityWizard.SolveType === 'F'
        ) {
          <mat-form-field class="col-6">
            <mat-label>Premium Amount</mat-label>
            @if (modalData.AnnuityWizard) {
              <input
                matInput
                attr.maxlength="20"
                name="premium"
                required
                [maskito]="dollarMask"
                [(ngModel)]="modalData.AnnuityWizard.InitialPremium"
              />
            }
          </mat-form-field>
        }

        @if (
          modalData.AnnuityWizard && modalData.AnnuityWizard.SolveType === 'B'
        ) {
          <mat-form-field class="col-6">
            <mat-label>Annual Income Amount</mat-label>
            @if (modalData.AnnuityWizard) {
              <input
                matInput
                attr.maxlength="20"
                name="premium"
                required
                [maskito]="dollarMask"
                [(ngModel)]="modalData.AnnuityWizard.IncomeNeeded"
              />
            }
          </mat-form-field>
        }

        <div
          class="container col-6 radio-btns"
          [ngClass]="{
            invalid:
              invalidAfterSubmit && !modalData.AnnuityWizard.JointProtection,
          }"
        >
          <div class="w-100">Single or Joint*</div>
          @if (modalData.AnnuityWizard) {
            <mat-radio-group
              name="jointSingle"
              required
              [(ngModel)]="modalData.AnnuityWizard.JointProtection"
            >
              <mat-radio-button value="1">Single</mat-radio-button>
              <mat-radio-button value="2" class="ms-3">Joint</mat-radio-button>
            </mat-radio-group>
          }
        </div>

        @if (
          modalData.AnnuityWizard?.JointProtection === 2 ||
          modalData.AnnuityWizard?.JointProtection === '2'
        ) {
          <mat-form-field class="mt-2 col-6">
            <mat-label>Joint Annuitant Age</mat-label>
            <input
              matInput
              name="spouseAge"
              type="number"
              step="1"
              required
              [(ngModel)]="modalData.SpouseEstimates.Age"
            />
          </mat-form-field>
        }

        @if (
          modalData.AnnuityWizard?.JointProtection === 2 ||
          modalData.AnnuityWizard?.JointProtection === '2'
        ) {
          <div
            class="container mt-2 col-6 radio-btns"
            [ngClass]="{
              invalid: invalidAfterSubmit && !modalData.SpouseEstimates.Gender,
            }"
          >
            <div class="w-100">Joint Annuitant Gender*</div>
            <mat-radio-group
              name="spouseGender"
              required
              [(ngModel)]="modalData.SpouseEstimates.Gender"
            >
              <mat-radio-button value="M">Male</mat-radio-button>
              <mat-radio-button value="F" class="ms-3">Female</mat-radio-button>
            </mat-radio-group>
          </div>
        }
      </form>
    </mat-dialog-content>
    <mat-dialog-actions class="col-11 buttons pull-right">
      <button type="button" mat-raised-button class="close" (click)="cancel()">
        Cancel
      </button>
      <button
        type="button"
        mat-raised-button
        color="accent"
        class="calculate"
        (click)="save()"
      >
        Calculate
      </button>
    </mat-dialog-actions>
  </div>
</div>
